import { render, staticRenderFns } from "./MonthlyPayroll.vue?vue&type=template&id=bda98042&scoped=true&"
import script from "./MonthlyPayroll.vue?vue&type=script&lang=js&"
export * from "./MonthlyPayroll.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPayroll.vue?vue&type=style&index=0&id=bda98042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda98042",
  null
  
)

export default component.exports